import { Avatar, Box, Container, Grid, Stack } from "@mui/material";
import React, { useEffect } from "react";
import {
  SectionCententSec,
  SectionTitleSec,
  SubTitle,
  SubTitleSec,
  WhiteSection,
} from "../../styles/HomeStyles";

import { motion } from "framer-motion";
import SvgCard from "../../components/SvgCard";

const DirectorsWord = ({ ...props }) => {
  return (
    <WhiteSection>
      <Container {...props}>
        <Grid justifyContent="center" alignItems="center" container spacing={2}>
          <Grid item xs={12} sm={5}>
            <SvgCard
              color="blue"
              src="./static/images/TiltCards/directors_word.jpg"
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <SectionTitleSec>Mot du directeur général:</SectionTitleSec>
            <SectionCententSec>
              Le Management de la <b>Qualité, Hygiène, Sécurité</b> et
              <b> Environnement</b> est une opportunité pour les entreprises,
              quelle que soit leur taille et leur secteur d'activité, qui
              souhaitent satisfaire leurs clients dans le respect des conditions
              d'hygiène et de sécurité des collaborateurs, et la préservation de
              l'environnement.
            </SectionCententSec>
            <SectionCententSec>
              L'engagement fort du Top Management, la forte implication des
              collaborateurs et la conformité réglementaire font la devise
              essentielle de la réussite et l'atteinte de l'excellence.
            </SectionCententSec>
            <SectionCententSec>
              La devise d'
              <SubTitle
                mr={0.5}
                sx={{ color: (theme) => theme.palette.primary.main }}
                variant="body"
              >
                AFRIQUALEOS
              </SubTitle>
              , est d'accompagner nos clients à atteindre l'excellence et de
              confirmer notre empreinte.
            </SectionCententSec>
            <Stack
              my={2}
              spacing={2}
              justifyContent="center"
              sx={{ justifyContent: { xs: "center", sm: "left" } }}
              direction="row"
            >
              <Avatar
                sx={{ width: 56, height: 56 }}
                src="./static/images/AT.png"
              />
              <Stack spacing={0} direction="column">
                <SubTitleSec fontWeight={900}>Ahmed TABIT</SubTitleSec>
                <SubTitleSec>Directeur général</SubTitleSec>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </WhiteSection>
  );
};

export default DirectorsWord;
